import { useAuth } from "@/hooks/use-auth";
import { usePermissions } from "@/hooks/use-permissions";
import { Lock } from "lucide-react";
import { Redirect, Route } from "wouter";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { FullscreenLoadingSpinner } from "@/components/ui/loading-spinner";

export function ProtectedRoute({
  path,
  component: Component,
}: {
  path: string;
  component: () => React.JSX.Element;
}) {
  const { user, isLoading } = useAuth();

  return (
    <Route path={path}>
      {isLoading ? (
        <FullscreenLoadingSpinner />
      ) : !user ? (
        <Redirect to="/auth" />
      ) : (
        <Component />
      )}
    </Route>
  );
}

export function PermissionProtectedRoute({
  path,
  component: Component,
  requiredResource,
  requiredAction = 'view',
}: {
  path: string;
  component: () => React.JSX.Element;
  requiredResource: string;
  requiredAction?: 'view' | 'create' | 'edit' | 'delete';
}) {
  const { user, isLoading } = useAuth();
  const permissions = usePermissions();

  return (
    <Route path={path}>
      {isLoading ? (
        <FullscreenLoadingSpinner />
      ) : !user ? (
        <Redirect to="/auth" />
      ) : (user.role === 'admin' || user.role === 'superadmin' || user.role === 'owner' || 
         (requiredResource === 'profile' && user) || // Každý používateľ má prístup k vlastnému profilu
         permissions.hasPermission(requiredResource, requiredAction)) ? (
        <Component />
      ) : (
        <div className="flex items-center justify-center min-h-screen p-6">
          <Alert className="max-w-md">
            <Lock className="h-4 w-4" />
            <AlertTitle>Prístup zamietnutý</AlertTitle>
            <AlertDescription>
              Nemáte oprávnenie na prístup k tejto stránke. Kontaktujte svojho administrátora pre udelenie potrebných oprávnení.
            </AlertDescription>
          </Alert>
        </div>
      )}
    </Route>
  );
}
